var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (model.get("errors") && model.get("errors").length > 0) { 
__p+='\n  ';
 model.get("errors").forEach(function(errorMessage) { 
__p+='\n    <div class="alert alert-danger">\n      '+
((__t=( errorMessage ))==null?'':__t)+
'\n    </div>\n  ';
 }) 
__p+='\n';
 } 
__p+='\n\n<p>Please indicate the area code you would like</p>\n\n<div class="row">\n  <div class="col-5">\n    <div data-mount="npa-selection"/>\n  </div>\n  <div class="col-7 border-left">\n    <label class="sb-field-label bold">Location Preference</label>\n    <p data-test-target="location-preference">\n      '+
((__t=( model.get("number_pool_location") ))==null?'':__t)+
'\n    </p>\n\n    ';
 if (model.get("number_pool_radius_checked")) { 
__p+='\n      <label class="sb-field-label bold">Radius Preference</label>\n      <p data-test-target="radius-preference">\n        '+
((__t=( model.get("number_pool_search_radius") ))==null?'':__t)+
' miles\n      </p>\n    ';
 } 
__p+='\n  </div>\n</div>\n';
}
return __p;
};
